import type { MailboxInfo } from "owa-client-types";
import { getFeatureFlagsIndexerForMailboxInfoPersistenceIdImpl } from "./getFeatureFlagsIndexerForMailboxInfoPersistenceIdImpl";

export default function getFeatureFlagsIndexerForMailboxInfo(mailboxInfo: MailboxInfo | undefined | null, errorIfNoAccountKey?: boolean): string {
    return getFeatureFlagsIndexerForMailboxInfoPersistenceIdImpl(mailboxInfo, errorIfNoAccountKey);
}
